var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

var useStyles = makeStyles(function (theme) {
  return {
    tag: _extends({
      border: '2px solid ' + (R.path(['palette', 'highlight', 'hl2'], theme) || theme.palette.primary.dark),
      borderRadius: 4,
      fontWeight: 700,
      padding: theme.spacing(0, 0.5)
    }, R.pathOr({}, ['mixins', 'tag', 'root'], theme))
  };
});

var Tag = function Tag(_ref) {
  var children = _ref.children,
      tagValueLabel = _ref.tagValueLabel;

  var classes = useStyles();

  if (R.isNil(children)) return null;

  return React.createElement(
    'div',
    null,
    React.createElement(
      Typography,
      { tabIndex: 0, className: classes.tag, 'aria-label': tagValueLabel },
      children
    )
  );
};

Tag.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  tagValueLabel: PropTypes.string
} : {};

export default Tag;